import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getOptimizedImageUrl(url, options = "width=800,quality=80,format=auto") {
  if (!url) return "";
  if (!url.startsWith("https://assets.auxodev.dk/")) return url;
  if (url.includes("/cdn-cgi/image/")) return url; // Already transformed
  
  return url.replace(
    "https://assets.auxodev.dk/",
    `https://assets.auxodev.dk/cdn-cgi/image/${options}/`
  );
}
